import React, { useEffect } from 'react';

function FormularioContactoCarbonBambu() {
  useEffect(() => {
    // Carga el script de HubSpot
    const script = document.createElement('script');
    script.src = '//js.hsforms.net/forms/embed/v2.js';
    script.type = 'text/javascript';
    script.charset = 'utf-8';
    script.onload = () => {
      // Inicializa el formulario de HubSpot
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: '47654427',
          formId: '66d83a3c-90aa-493b-9b0e-4b4b8d0b16b4',
          target: '#hubspotForm',
        });
      }
    };
    document.body.appendChild(script);
  }, []);

  return (
    <section id="contacto" className="bg-light"> {/* Agregamos id="contacto" */}
      <div className="container">
        <div className="title-style2 text-center mb-2-2">
          <h2 className="h1">¡Contáctanos para más información o una cotización personalizada!</h2>
        </div>
        <div className="row">
          <div 
            className="col-lg-8 mb-5 mb-lg-0 mb-md-5 mx-auto wow fadeIn" 
            data-wow-delay="400ms"
          >
            <div className="contact-form p-4 p-md-5 bg-white rounded">
              <form className="quform">
                {/* Aquí se insertará el formulario de HubSpot */}
                <div id="hubspotForm"></div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FormularioContactoCarbonBambu;
